export default __webpack_public_path__ + "static/media/evolucao-genetica.d365814e.svg";